import { __HiringLang } from '../hiringList/hiringList.lang';

export const __HiringSortList: (lang: typeof __HiringLang) => { title: string; slug: string }[] = (lang) => [
    { title: lang.newest, slug: '-created_at' },
    { title: lang.mostRelated, slug: 'most_related' },
];
